<template>
  <AppNavbar />
  <router-view />
</template>

<script setup>
import AppNavbar from "@/components/AppNavbar.vue";
</script>

<style>
@import "/node_modules/bulma/css/bulma.min.css";
@import url("https://fonts.googleapis.com/css2?family=Google+Sans:ital,opsz,wght@0,17..18,400..700;1,17..18,400..700&display=swap");

html,
body {
  font-family: "Google Sans", sans-serif;
}

input,
textarea,
select,
button {
  font-family: inherit;
}
</style>
